<template>
    <section class="contract-click-sign-flow-content-first-config scroll-color">
        <div class="configurations">
            <span class="text-config">1 - Configurações</span>
            <span class="define-signature">Faça as definições para assinatura digital do contrato</span>
        </div>

        <div class="flow-signature">
            <ui-input
                v-model="form.data.name"
                :maxlength="45"
                label="Nome do fluxo de assinatura:"
                placeholder="Ex. Assinatura Contrato"
                required
            />
        </div>

        <div class="envelope-status">
            <div class="envelope-status-content">
                <section class="subscription-simultaneous">
                    <div class="subscription-simultaneous-text">
                        <span class="title">Assinatura simultânea</span>

                        <span class="subtitle">Por padrão, os assinantes recebem a solicitação um de cada vez, seguindo a ordem definida acima.</span>
                    </div>

                    <div class="subscription-simultaneous-switch">
                        <ui-switch
                            v-model="form.data.send_simultaneous"
                            design="sm mgb-0"
                            :checked="form.data.send_simultaneous"
                        />
                    </div>
                </section>

                <section class="subscription-reminder">
                    <div class="subscription-reminder-text">
                        <span class="title">Lembrete de Assinatura</span>

                        <span class="subtitle">Frequência de notificação dos assinantes sobre assinaturas pendentes.</span>
                    </div>

                    <div class="subscription-reminder-select">
                        <ui-select-v2
                            v-model="form.data.remind_interval"
                            :data="remindIntervalOptions"
                            background-color="#FFF"
                            return-value="label"
                            placeholder="Selecione um intervalo"
                            size="lg"
                        />
                    </div>
                </section>

                <section class="subscription-timeout">
                    <div class="subscription-timeout-text">
                        <span class="title">Tempo limite para Assinatura</span>

                        <span class="subtitle">Quantos dias os assinantes tem para assinar o documento?</span>
                    </div>

                    <div class="subscription-timeout-select">
                        <ui-input-number
                            v-model="form.data.deadline_at"
                            :max-value="90"
                            size="md"
                        />
                    </div>
                </section>

                <section class="message">
                    <div class="message-text">
                        <span class="title">Mensagem<span class="label-required">*</span></span>

                        <span class="subtitle">Digite uma mensagem para os signatários.</span>
                    </div>

                    <div class="message-textarea">
                        <ui-textarea v-model="form.data.default_message" required background-color="#FFF" />
                    </div>
                </section>

                <section class="automatically-close-envelope">
                    <div class="automatically-close-envelope-text">
                        <span class="title">Fechar envelope automaticamente</span>

                        <span class="subtitle">Digite uma mensagem para os signatários.</span>
                    </div>

                    <div class="automatically-close-envelope-switch">
                        <ui-switch
                            v-model="form.data.auto_close"
                            :checked="form.data.auto_close"
                            design="sm"
                        />
                    </div>
                </section>
            </div>

            <div class="footer-button">
                <ui-button
                    :disabled="!canSubmit"
                    design="mw-200 primary lg"
                    @click="next">
                    Avançar
                </ui-button>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import {
        uiInput,
        uiSelectV2,
        uiTextarea,
        uiSwitch,
        uiInputNumber
    } from '@/components/ui/form'

    import { mapGetters, mapActions } from 'vuex'

	export default {
		name: 'ui-click-sign-contract-sign-flow-config',

		components: {
			uiButton,
            uiInput,
            uiSelectV2,
            uiTextarea,
            uiSwitch,
            uiInputNumber
		},

        data() {
            return {
                form: {
                    data: {
                        name: '',
                        has_documentation: false,
						send_simultaneous: false,
                        remind_interval: 1,
                        deadline_at: 5,
                        auto_close: false,
                        message: '',
                        locale: 'pt-BR',
                        block_after_refusal: false
                    }
                },
                remindIntervalOptions: [1, 2, 3, 7, 14],
                unsubscribe: null
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                envelope: 'getEnvelope'
            }),
            /**
             * Computed property que define se as configurações podem ser salvas
             */
			canSubmit() {
				return !!this.form.data.name && !!this.form.data.default_message
			}
        },

        created() {
			/** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                // Verifica se uma nova configuração de envelope foi setada
                if (mutation.type === 'digitalSignatureStore/SET_ENVELOPE') {
                    if (!mutation.payload?.name) {
                        this.form.data = {
                            ...mutation.payload,
                            name: '',
                            message: mutation.message || ''
                        }
                    }
                }
            })
        },

        beforeDestroy() {
            this.unsubscribe()
        },

        methods: {
            ...mapActions('digitalSignatureStore', ['setEnvelope']),
            /**
             * Salva as configurações e passa para a próxima etapa
             */
			next() {
                this.setEnvelope(this.form.data)
                this.$emit('next')
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>